'use strict';

var React = require('react'),
    _     = require('underscore');

/*

CSS classes:

question-title
question-title, title-active

title-active means the title is bein displayed.
This is not the case if for example the textinput has no value,
so the title has not animated out of the placeholder yet

*/

var QuestionError = React.createClass({

  propTypes: {
    error: React.PropTypes.string,
    active: React.PropTypes.bool.isRequired
  },

  getDefaultProps: function() {
    return {
      error: "I am an error yay"
    };
  },

  render: function() {
    var className = "QuestionError";
    if (this.props.active) {
      className += " active";
    }

    return (
      <div
        key="question-error"
        className={className}>
        {this.props.error}
      </div>
    );
  }
});

module.exports = QuestionError;



/** WEBPACK FOOTER **
 ** ./js/screens/form/application-question-error.jsx
 **/